import { inject, Injectable, Signal } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { toSignal } from "@angular/core/rxjs-interop";
import { filter, map, Observable, of } from "rxjs";

@Injectable()
export class UpdatePromptService {
    private swUpdate = inject(SwUpdate, { optional: true });

    public updateAvailable: Signal<boolean> = toSignal(this.promptUpdate(), { initialValue: false });

    public async updateAndRestart(): Promise<void> {
        if (!this.swUpdate) {
            return;
        }
        await this.swUpdate.activateUpdate().then(() => window.location.reload());
    }

    private promptUpdate(): Observable<boolean> {
        if (!this.swUpdate) {
            return of(false);
        } else {
            return this.swUpdate.versionUpdates.pipe(
                filter((evt): evt is VersionReadyEvent => evt.type === "VERSION_READY"),
                map(() => true)
            );
        }
    }
}
